// extracted by mini-css-extract-plugin
export default {"menuButtonWrapper":"editMultipleMoreMenu_menuButtonWrapper__ib4pa"};